import { appURLs } from "@/app/constants.mjs";
import * as GraphQLTemplates from "@/feature-subscriber/graphql-templates.mjs";
import type { PaymentProviderType } from "@/feature-wallet/models/payment-method-provider.mjs";
import { postGQL, queryGQL } from "@/util/gql-formatters.mjs";

export function getProPricing({
  paymentMethodId,
  providerType,
  includeUserInfo = false,
}: {
  paymentMethodId?: string;
  providerType: PaymentProviderType;
  includeUserInfo?: boolean;
}) {
  return queryGQL(appURLs.PAYMENTS, GraphQLTemplates.proPricing, {
    paymentMethodId,
    providerType,
    includeUserInfo,
  });
}

export function createSubscription({
  couponCode,
  isTrial,
  paymentMethodId,
  plan,
  providerType,
}: {
  couponCode: string;
  isTrial: boolean;
  paymentMethodId: string;
  plan: string;
  providerType: PaymentProviderType;
}) {
  return postGQL(appURLs.PAYMENTS, GraphQLTemplates.subscribeToPro, {
    couponCode,
    isTrial,
    paymentMethodId,
    plan,
    providerType,
  });
}

export function renewSubscription({
  paymentMethodId,
  plan,
  providerType,
}: {
  paymentMethodId: string;
  plan: string;
  providerType: PaymentProviderType;
}) {
  return postGQL(appURLs.PAYMENTS, GraphQLTemplates.subscribeToPro, {
    paymentMethodId,
    plan,
    providerType,
  });
}
